export default __webpack_public_path__ + "postMock-1747840038663.html";